import { obtenerExtrasHitoricoAction } from "./../../../ducks/extrasContratadosHistorialDuck"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import TExtrasHistorico from "./TExtrasHistorico."

const VExtrasHistorico = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerExtrasHitoricoAction())
    },[])
    return (
        <div>
            <TExtrasHistorico />
        </div>
    )
}
export default VExtrasHistorico